import { GetMainSectionFn } from '../custom-topic-routes'
import { topicParallax } from '../topic-parallax'
import { billboardLeaderboardMrec } from 'thewest/routes/ad-units'

const topicId = 'features/kerry-stokes-collection'

export const getKerryStokesCollectionRouteInfo: GetMainSectionFn = () => {
    return [
        {
            type: 'lima',
            props: {
                verticalSpacing: 'md',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                hasBackground: true,

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: [topicId],
                    includeSubTopics: true,
                    publicationKind: 'galleryAndArticle',
                    paging: {
                        page: 1,
                        pageSize: 8,
                    },
                },
            },
        },
        ...topicParallax(),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'md',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: [topicId],
                    includeSubTopics: true,
                    publicationKind: 'galleryAndArticle',
                    paging: {
                        page: 1,
                        pageOffset: 8,
                        pageSize: 8,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('one'),
        {
            type: 'lima',
            props: {
                verticalSpacing: 'md',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,

                loadMoreEnabled: true,

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: [topicId],
                    includeSubTopics: true,
                    publicationKind: 'galleryAndArticle',
                    paging: {
                        page: 1,
                        pageOffset: 16,
                        pageSize: 8,
                    },
                },
            },
        },
        ...billboardLeaderboardMrec('two'),
    ]
}
